import { SetHeaderService } from "@/helper/userHelper";
import service from "../baseHttpService";

class TransactionService {
  DoGetProductRequisitionViewDetailList(productRequisitionIdList: Array<number>) {
    const _input = {
      productRequisitionIdList: productRequisitionIdList,
    };
    return service.peakExportAPI
      .post("/api/Transaction/GetProductRequisitionViewDetailList", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetPurchaseRequisitionViewDetailList(purchaseRequisitionIdList: Array<number>) {
    const _input = {
      purchaseRequisitionIdList: purchaseRequisitionIdList,
    };
    return service.peakExportAPI
      .post("/api/Transaction/GetPurchaseRequisitionViewDetailList", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetQuotationViewDetailList(quotationIdList: Array<number>) {
    const _input = {
      quotationIdList: quotationIdList,
    };
    return service.peakExportAPI
      .post("/api/Transaction/GetQuotationViewDetailList", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetInvoiceViewDetailList(invoiceIdList: Array<number>) {
    const _input = {
      invoiceIdList: invoiceIdList,
    };
    return service.peakExportAPI
      .post("/api/Transaction/GetInvoiceViewDetailList", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetReceiptViewDetailList(receiptIdList: Array<number>) {
    const _input = {
      receiptIdList: receiptIdList,
    };
    return service.peakExportAPI
      .post("/api/Transaction/GetReceiptViewDetailList", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetTaxInvoiceViewDetailList(taxInvoiceIdList: Array<number>) {
    const _input = {
      taxInvoiceIdList: taxInvoiceIdList,
    };
    return service.peakExportAPI
      .post("/api/Transaction/GetTaxInvoiceViewDetailList", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetCreditNoteViewDetailList(creditNoteIdList: Array<number>) {
    const _input = {
      creditNoteIdList: creditNoteIdList,
    };
    return service.peakExportAPI
      .post("/api/Transaction/GetCreditNoteViewDetailList", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetBillingNoteViewDetailList(billingNoteIdList: Array<number>) {
    const _input = {
      billingNoteIdList: billingNoteIdList,
    };
    return service.peakExportAPI
      .post("/api/Transaction/GetBillingNoteViewDetailList", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetDebitNoteViewDetailList(debitNoteIdList: Array<number>) {
    const _input = {
      debitNoteIdList: debitNoteIdList,
    };
    return service.peakExportAPI
      .post("/api/Transaction/GetDebitNoteViewDetailList", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetDepositViewDetailList(depositIdList: Array<number>) {
    const _input = {
      depositIdList: depositIdList,
    };
    return service.peakExportAPI
      .post("/api/Transaction/GetDepositViewDetailList", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetGoodsReceiptViewDetailList(goodsReceiptIdList: Array<number>) {
    const _input = {
      goodsReceiptIdList: goodsReceiptIdList,
    };
    return service.peakExportAPI
      .post("/api/Transaction/GetGoodsReceiptViewDetailList", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetInvoiceReceiptViewDetailList(invoiceReceiptIdList: Array<number>) {
    const _input = {
      invoiceReceiptIdList: invoiceReceiptIdList,
    };
    return service.peakExportAPI
      .post("/api/Transaction/GetInvoiceReceiptViewDetailList", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
}

export default new TransactionService();
